import { convertStringToArray } from 'app/utils/formatUtils';

export const billingSystemTypeServer = {
  OLAQIN_HARDWARE: 'HARDWARE',
  OLAQIN_SERVICE: 'SERVICE',
  AFFID: 'AFFID',
};

export const sageBaseTypes = {
  [billingSystemTypeServer.OLAQIN_HARDWARE]: 'HARDWARE',
  [billingSystemTypeServer.OLAQIN_SERVICE]: 'SERVICE',
  [billingSystemTypeServer.AFFID]: 'AFFID',
};

export const billingSystemTypeOptions = [
  {
    label: 'Sage Olaqin HARDWARE',
    value: billingSystemTypeServer.OLAQIN_HARDWARE,
  },
  {
    label: 'Sage Olaqin SERVICE',
    value: billingSystemTypeServer.OLAQIN_SERVICE,
  },
  {
    label: 'Sage Affid',
    value: billingSystemTypeServer.AFFID,
  },
];

export const specialityOptions = [
  { label: 'ACTIVITE MEDICALE', value: 'ACTIVITE_MEDICALE' },
  { label: 'ALLERGOLOGUE', value: 'ALLERGOLOGUE' },
  { label: 'ANESTHESISTE', value: 'ANESTHESISTE' },
  { label: 'ANGIOLOGUE', value: 'ANGIOLOGUE' },
  { label: 'ARCHITECTE', value: 'ARCHITECTE' },
  { label: 'ASSOCIATION', value: 'ASSOCIATION' },
  { label: 'AUTRE', value: 'AUTRE' },
  { label: 'AUTRES PROF LIB', value: 'AUTRES_PROF_LIB' },
  { label: 'BIOLOGISTE', value: 'BIOLOGISTE' },
  { label: 'CABINET COMPTABLE', value: 'CABINET_COMPTABLE' },
  { label: 'CANCEROLOGUE', value: 'CANCEROLOGUE' },
  { label: 'CARDIOLOGUE', value: 'CARDIOLOGUE' },
  { label: 'CENTRE FORMATION', value: 'CENTRE_FORMATION' },
  { label: 'CHIRURGIE', value: 'CHIRURGIE' },
  { label: 'CHIRURGIE DENTA', value: 'CHIRURGIE_DENTA' },
  { label: 'CHIRURGIE ORTHO', value: 'CHIRURGIE_ORTHO' },
  { label: 'CHIRURGIE VASCULAIRE', value: 'CHIRURGIE_VASCULAIRE' },
  { label: 'CHIRURGIE VISCERALE', value: 'CHIRURGIE_VISCERALE' },
  { label: 'CHIRURGIEN', value: 'CHIRURGIEN' },
  { label: 'CNDA', value: 'CNDA' },
  { label: 'CONSULTANT', value: 'CONSULTANT' },
  { label: 'CPAM', value: 'CPAM' },
  { label: 'CYTOLOGIE', value: 'CYTOLOGIE' },
  { label: 'DENTISTE', value: 'DENTISTE' },
  { label: 'DERMATOLOGUE', value: 'DERMATOLOGUE' },
  { label: 'DIETETICIENNE', value: 'DIETETICIENNE' },
  { label: 'DIVERS', value: 'DIVERS' },
  { label: 'ECHOGRAPHISTE', value: 'ECHOGRAPHISTE' },
  { label: 'EDITEUR', value: 'EDITEUR' },
  { label: 'ENCADREMENT', value: 'ENCADREMENT' },
  { label: 'ENDOCRINOLOGIE', value: 'ENDOCRINOLOGIE' },
  { label: 'ENDOCRINOLOGUE', value: 'ENDOCRINOLOGUE' },
  { label: 'ERGOTHERAPEUTE', value: 'ERGOTHERAPEUTE' },
  { label: 'EXPERT COMPTABLE', value: 'EXPERT_COMPTABLE' },
  { label: 'FOURNISSEUR', value: 'FOURNISSEUR' },
  { label: 'GASTRO ENTEROLOGUE', value: 'GASTRO_ENTEROLOGUE' },
  { label: 'GENERALISTE', value: 'GENERALISTE' },
  { label: 'GERIATRE', value: 'GERIATRE' },
  { label: 'GERONTOLOGUE', value: 'GERONTOLOGUE' },
  { label: 'GYNECOLOGUE', value: 'GYNECOLOGUE' },
  { label: 'HYPNOTHERAPEUTE', value: 'HYPNOTHERAPEUTE' },
  { label: 'INFIRMIER', value: 'INFIRMIER' },
  { label: 'INFIRMIERE', value: 'INFIRMIERE' },
  { label: 'INFORMATIQUE', value: 'INFORMATIQUE' },
  { label: 'INGENIEUR COMMERCIAL', value: 'INGENIEUR_COMMERCIAL' },
  { label: 'INGENIEUR CONSEIL', value: 'INGENIEUR_CONSEIL' },
  { label: 'KINE', value: 'KINE' },
  { label: 'LABORATOIRE', value: 'LABORATOIRE' },
  { label: 'MAISON MEDICALE', value: 'MAISON_MEDICALE' },
  { label: 'MEDECIN DIM', value: 'MEDECIN_DIM' },
  { label: 'MEDECIN INTERNE', value: 'MEDECIN_INTERNE' },
  { label: 'MEDECIN RADIOTHERAPEUTE', value: 'MEDECIN_RADIOTHERAPEUTE' },
  { label: 'MEDECINE DU SOMMEIL', value: 'MEDECINE_DU_SOMMEIL' },
  { label: 'MEDECINE DU TRAVAIL', value: 'MEDECINE_DU_TRAVAIL' },
  { label: 'MEDECINE INTERNE', value: 'MEDECINE_INTERNE' },
  { label: 'MEDECINE NUCLEAIRE', value: 'MEDECINE_NUCLEAIRE' },
  { label: 'MEDECINE PHYSIQUE', value: 'MEDECINE_PHYSIQUE' },
  { label: 'MEDECINE SPORTIVE', value: 'MEDECINE_SPORTIVE' },
  { label: 'MEDECINE VASCULAIRE', value: 'MEDECINE_VASCULAIRE' },
  { label: 'NEGOCIANT AUTO', value: 'NEGOCIANT_AUTO' },
  { label: 'NEPHROLOGUE', value: 'NEPHROLOGUE' },
  { label: 'NEUROLOGUE', value: 'NEUROLOGUE' },
  { label: 'NEUROPSYCHIATRE', value: 'NEUROPSYCHIATRE' },
  { label: 'NUTRITIONNISTE', value: 'NUTRITIONNISTE' },
  { label: 'ONCOLOGUE', value: 'ONCOLOGUE' },
  { label: 'OPHTALMOLOGISTE', value: 'OPHTALMOLOGISTE' },
  { label: 'ORG. FINANCEMENT', value: 'ORG_FINANCEMENT' },
  { label: 'ORL', value: 'ORL' },
  { label: 'ORTHESISTE', value: 'ORTHESISTE' },
  { label: 'ORTHODONTISTE', value: 'ORTHODONTISTE' },
  { label: 'ORTHOPEDISTE', value: 'ORTHOPEDISTE' },
  { label: 'ORTHOPHONISTE', value: 'ORTHOPHONISTE' },
  { label: 'ORTHOPTISTE', value: 'ORTHOPTISTE' },
  { label: 'OSTEOPATHE', value: 'OSTEOPATHE' },
  { label: 'PEDIATRE', value: 'PEDIATRE' },
  { label: 'PHLEBOLOGUE', value: 'PHLEBOLOGUE' },
  { label: 'PHOTOGRAPHE', value: 'PHOTOGRAPHE' },
  { label: 'PNEUMOLOGUE', value: 'PNEUMOLOGUE' },
  { label: 'PODOLOGUE', value: 'PODOLOGUE' },
  { label: 'PSYCHANALYSTE', value: 'PSYCHANALYSTE' },
  { label: 'PSYCHIATRE', value: 'PSYCHIATRE' },
  { label: 'PSYCHOLOGUE', value: 'PSYCHOLOGUE' },
  { label: 'RADIOLOGUE', value: 'RADIOLOGUE' },
  { label: 'REVENDEUR', value: 'REVENDEUR' },
  { label: 'RHUMATOLOGUE', value: 'RHUMATOLOGUE' },
  { label: 'SAGE-FEMME', value: 'SAGE_FEMME' },
  { label: 'SAMU', value: 'SAMU' },
  { label: 'SEXOLOGUE', value: 'SEXOLOGUE' },
  { label: 'SOCIETE', value: 'SOCIETE' },
  { label: 'STOMATOLOGIE', value: 'STOMATOLOGIE' },
  { label: 'STOMATOLOGUE', value: 'STOMATOLOGUE' },
  { label: 'URGENTISTE', value: 'URGENTISTE' },
  { label: 'UROLOGUE', value: 'UROLOGUE' },
  { label: 'VETO', value: 'VETO' },
];

export const qualityOptions = [
  { label: 'Association', value: 'ASSOCIATION' },
  { label: 'Cabinet', value: 'CABINET' },
  { label: 'Centre', value: 'CENTRE' },
  { label: 'Clinique', value: 'CLINIQUE' },
  { label: 'Docteur', value: 'DOCTEUR' },
  { label: 'Docteurs', value: 'DOCTEURS' },
  { label: 'Madame', value: 'MADAME' },
  { label: 'Mademoiselle', value: 'MADEMOISELLE' },
  { label: 'Monsieur', value: 'MONSIEUR' },
  { label: 'Société', value: 'SOCIETE' },
  { label: 'Trésorier', value: 'TRESORIER' },
];

export const thirdPartyPayerOptions = [
  { label: 'Ce client est le tiers payeur', value: 'Ce client est le tiers payeur' },
  { label: 'Le tiers payeur est un autre client', value: 'Le tiers payeur est un autre client' },
];

export const salesTypologyOptions = [
  { label: 'Ancien Client', value: 'ANCIENT_CLIENT' },
  { label: 'Association', value: 'ASSOCIATION' },
  { label: 'Assurance', value: 'ASSURANCE' },
  { label: 'Auchan', value: 'AUCHAN' },
  { label: 'Audition', value: 'AUDITION' },
  { label: 'Autre', value: 'AUTRE' },
  { label: 'BIO ACCESS', value: 'BIO_ACCESS' },
  { label: 'BIOGROUP', value: 'BIOGROUP' },
  { label: 'Boutique de logiciels', value: 'BOUTIQUE_DE_LOGICIELS' },
  { label: 'CAIH', value: 'CAIH' },
  { label: 'CERBALLIANCE', value: 'CERBALLIANCE' },
  { label: 'Centre Hospitalier', value: 'CENTRE_HOSPITALIER' },
  { label: 'Centre Hospitalier Prive', value: 'CENTRE_HOSPITALIER_PRIVE' },
  { label: 'Centre de sante - Cabinet medical', value: 'CENTRE_DE_SANTE_CABINET_MEDICAL' },
  { label: 'Client Affid', value: 'AFFID_CLIENT' },
  { label: 'Client CAIH by Stellair', value: 'CLIENT_CAIH_BY_STELLAIR' },
  { label: 'Client Stellair', value: 'CLIENT_STELLAIR' },
  { label: 'Client Stellair Affid', value: 'STELLAIR_AFFID_CLIENT' },
  { label: 'Clinique et Polyclinique', value: 'CLINIQUE_ET_POLYCLINIQUE' },
  { label: 'Clinique et Polyclinique Prive', value: 'CLINIQUE_ET_POLYCLINIQUE_PRIVE' },
  { label: 'Cure Thermale', value: 'CURE_THERMALE' },
  { label: 'EHPAD', value: 'EHPAD' },
  { label: 'Etablissement Public', value: 'ETABLISSEMENT_PUBLIC' },
  { label: 'Grossiste - revendeur', value: 'GROSSISTE_REVENDEUR' },
  { label: 'HARMONIE MUTUELLE', value: 'HARMONIE_MUTUELLE' },
  { label: 'Imagerie medicale', value: 'IMAGERIE_MEDICALE' },
  { label: 'Imagerie medicale Prive', value: 'IMAGERIE_MEDICALE_PRIVE' },
  { label: 'Infirmier', value: 'INFIRMIER' },
  { label: 'Laboratoire', value: 'LABORATOIRE' },
  { label: 'Magasin de materiel medical', value: 'MAGASIN_DE_MATERIEL_MEDICAL' },
  { label: 'Mairie', value: 'MAIRIE' },
  { label: 'Medecin', value: 'MEDECIN' },
  { label: 'Mutuelle et prevoyance', value: 'MUTUELLE_ET_PREVOYANCE' },
  { label: 'ORPEA', value: 'ORPEA' },
  { label: 'Optique', value: 'OPTIQUE' },
  { label: 'Partenaire Stellair', value: 'PARTENAIRE_STELLAIR' },
  { label: 'Pharmacie', value: 'PHARMACIE' },
  { label: 'THELEM ASSURANCE', value: 'THELEM_ASSURANCE' },
];

export const classificationGieOptions = [
  { label: 'Autre lieu', value: 'AUTRE_LIEU' },
  { label: 'Autre établissement de soins', value: 'AUTRE_ETABLISSEMENT_DE_SOINS' },
  { label: 'Auxiliaire médical', value: 'AUXILIAIRE_MEDICAL' },
  { label: 'Centre de santé', value: 'CENTRE_DE_SANTE' },
  { label: 'Clinique et polyclinique', value: 'CLINIQUE_ET_POLYCLINIQUE' },
  { label: 'Dentiste', value: 'DENTISTE' },
  { label: 'Hôpital', value: 'HOPITAL' },
  { label: 'La Poste', value: 'LA_POSTE' },
  { label: "Laboratoire d'analyses médicales", value: 'LABORETOIRE_D_ANALYSES_MEDICALES' },
  { label: 'Mairie', value: 'MAIRIE' },
  { label: 'Médecin', value: 'MEDECIN' },
  {
    label: 'Organisme assurance maladie complémentaire',
    value: 'ORGANISME_ASSURANCE_MALADIE_COMPLEMENTAIRE',
  },
  {
    label: 'Organisme assurance maladie obligatoire',
    value: 'ORGANISME_ASSURANCE_MALADIE_OBLIGATOIRE',
  },
  { label: 'Pharmacie', value: 'PHARMACIE' },
  { label: 'Professionnel de la LPP', value: 'PROFESSIONNEL_DE_LA_LPP' },
  { label: 'Transporteur', value: 'TRANSPORTEUR' },
];

export const targetCibleOptions = [
  { label: 'AFFID Nxt', value: 'AFFID_NXT' },
  { label: 'CD2019 AFFID_ASSO', value: 'CD2019_AFFID_ASSO' },
  { label: 'CD2019 AFFID_INDIV', value: 'CD2019_AFFID_INDIV' },
  { label: 'CD2019 AJOUT', value: 'CD2019_AJOUT' },
  { label: 'CD2019 DASTOT', value: 'CD2019_DASTOT' },
  { label: 'CD2019 HELPINFO', value: 'CD2019_HELPINFO' },
  { label: 'CD2019 PHC', value: 'CD2019_PHC' },
  { label: 'CD2019 REV', value: 'CD2019_REV' },
  { label: 'CD2020 AFFID ASSO', value: 'CD2020_AFFID_ASSO' },
  { label: 'CD2020 AFFID HELPINFO', value: 'CD2020_AFFID_HELPINFO' },
  { label: 'CD2020 AFFID INDIV', value: 'CD2020_AFFID_INDIV' },
  { label: 'CD2020 AFFID REV', value: 'CD2020_AFFID_REV' },
  { label: 'MAD NEO', value: 'MAD_NEO' },
  { label: 'MAD PRIUM', value: 'MAD_PRIUM' },
  { label: 'MAD TPE-IWL SEUL', value: 'MAD_TPE_IWL_SEUL' },
  { label: 'MMG STL ILL+SUPC', value: 'MMG_STL_ILL_SUPC' },
  { label: 'MMG STL ILL+SUPC+PRIUM', value: 'MMG_STL_ILL_SUPC_PRIUM' },
  { label: 'MMG STL ILL+SUPO', value: 'MMG_STL_ILL_SUPO' },
  { label: 'MMG STL ILL+SUPO+PRIUM', value: 'MMG_STL_ILL_SUPO_PRIUM' },
  { label: 'NXT2019', value: 'NXT2019' },
  { label: 'NXT2021', value: 'NXT2021' },
  { label: 'NXT2021REV', value: 'NXT2021REV' },
  { label: 'NXT2022', value: 'NXT2022' },
  { label: 'NXT2022+PRIUM', value: 'NXT2022_PRIUM' },
  { label: 'NXT2022REV', value: 'NXT2022REV' },
  { label: 'NXT2023', value: 'NXT2023' },
  { label: 'NXT2023REV', value: 'NXT2023REV' },
  { label: 'PYXVITAL', value: 'PYXVITAL' },
  { label: 'STL ILL', value: 'STL_ILL' },
  { label: 'STL ILL+NEO', value: 'STL_ILL_NEO' },
  { label: 'STL ILL+NEO+PRIUM', value: 'STL_ILL_NEO_PRIUM' },
  { label: 'STL ILL+PRIUM', value: 'STL_ILL_PRIUM' },
  { label: 'STL ILL+TPE', value: 'STL_ILL_TPE' },
  { label: 'STL OLAQIN', value: 'STL_OLAQIN' },
  { label: 'STL USAG', value: 'STL_USAG' },
  { label: 'STL USAG+NEO', value: 'STL_USAG_NEO' },
  { label: 'CD2020 REV', value: 'CD2020_REV' },
  { label: 'CD2020 HELPINFO', value: 'CD2020_HELPINFO' },
  { label: 'CD2017', value: 'CD2017' },
  { label: 'CD2017 REV', value: 'CD2017_REV' },
  { label: 'CD2014 AFFID INDIV', value: 'CD2014_AFFID_INDIV' },
  { label: 'NXT2023+MAD', value: 'NXT2023_MAD' },
  { label: 'CD2017 AFFID INDIV', value: 'CD2017_AFFID_INDIV' },
  { label: 'CD2018 AFFID ASSO', value: 'CD2018_AFFID_ASSO' },
  { label: 'CD2018 AFFID INDIV', value: 'CD2018_AFFID_INDIV' },
  { label: 'CD2016', value: 'CD2016' },
  { label: 'CD2017 AFFID ASSO', value: 'CD2017_AFFID_ASSO' },
  { label: 'STL USAG+PRIUM', value: 'STL_USAG_PRIUM' },
];

export const customerNatureOptions = [
  { label: 'Direct', value: 'DIRECT' },
  { label: 'Indirect', value: 'INDIRECT' },
];

export const categoryOptions = [
  { label: 'AFFID', value: 'AFFID' },
  { label: 'ARRET', value: 'ARRET' },
  { label: 'ARRET Activité', value: 'ARRET_ACTIVITE' },
  { label: 'ARRET Activité Libérale', value: 'ARRET_ACTIVITE_LIBERALE' },
  { label: 'ARRET Cde Annulée', value: 'ARRET_CDE_ANNULEE' },
  { label: 'ARRET Chgt Logiciel', value: 'ARRET_CHGT_LOGICIEL' },
  { label: 'ARRET Congés', value: 'ARRET_CONGES' },
  { label: 'ARRET Déconventionné', value: 'ARRET_DECONVENTIONNE' },
  { label: 'ARRET Retraite', value: 'ARRET_RETRAITE' },
  { label: 'ARRET Sans Motif', value: 'ARRET_SANS_MOTIF' },
  { label: 'Client', value: 'CLIENT' },
  { label: 'Client OLAQIN', value: 'CLIENT_OLAQIN' },
  { label: 'Client PàJ', value: 'CLIENT_PAJ' },
  { label: 'CPAM', value: 'CPAM' },
  { label: 'Editeur', value: 'EDITEUR' },
  { label: 'Revendeur', value: 'REVENDEUR' },
  { label: 'Suspension ABO', value: 'SUSPENSION_ABO' },
];

export const sponsorshipOptions = [
  { label: 'PARRAIN1', value: 'PARRAIN1' },
  { label: 'PARRAIN2', value: 'PARRAIN2' },
  { label: 'PARRAIN3', value: 'PARRAIN3' },
  { label: 'PARRAIN4', value: 'PARRAIN4' },
  { label: 'PARRAIN5', value: 'PARRAIN5' },
  { label: 'PARRAIN6', value: 'PARRAIN6' },
  { label: 'PARRAIN7', value: 'PARRAIN7' },
  { label: 'PARRAIN8', value: 'PARRAIN8' },
  { label: 'PARRAIN9', value: 'PARRAIN9' },
  { label: 'PARRAIN10', value: 'PARRAIN10' },
  { label: 'PARRAIN11', value: 'PARRAIN11' },
  { label: 'PARRAIN12', value: 'PARRAIN12' },
  { label: 'FILLEUL', value: 'FILLEUL' },
];

const groupList = [
  'ABADI,  SCMLEGREGAM,  SCMBMSUD,  SCMVILABISA,  KRIZMANIC,  FAVELLE,  ABGRALLROQUE,  SCMCHAPLAIS,  PIETRI2,  SCMTERRASSON,  ADAMO,  UMGCPEUPLIERS,  SCMSZIDON,  AGBO,  SCMBITBOL,  CPFMASSYRYTH,  SCMROUXTHOMA,  SCMPOTERIE,  SCMPASTEUR2,  SCMBALLOULKA,  CABSTHILAIRE,  MSPATHISMONS,  SELARLDOTTO,  LELU,  MMBECHEREL,  DUQUESNOY,  LASSENE,  SCMASCLEPIO1,  SCMPERI1,  SCMJOHANN,  SCMCHANTELAR,  SELARLVAUBAN,  HEID,  SCMMEDSPORT,  SCMBELLEFEUI,  SCMVICTORY,  SCMLOUVEL,  MANENT,  SCMTILLEULS,  LOIREINTERME,  SCMPESSAC,  MUIR,  SCPVAUBAN,  PLAIS,  SCMVALTHORENS,  ARNOLD,  CABINETECOUE,  DREUX,  SCMEPINAY,  HUGUENIN,  GUILLET,  SCMECHONANTE,  SELARLAVORIA,  NOEL1,  SCMAUMALABI,  SCMSOCAM,  SCMAUDOMAROI,  SAYET,  SCMBELVEZEAZ,  CABAZOULAY,  AZOULAY2,  SCMCHAPELLE,  SCMDELATILLE,  QUIEN,  MONDAN,  BADETPHAN,  BAKHTI,  SCMBALANSARD,  SCMPERRIN,  SCMDIACONAT,  SCMBARNI,  BARD1,  DURIN1,  SCMJOURDES,  SCMRENELAENN,  SCMSAINTLUC,  POIRIER2,  SCMLEVIGNAC,  BAUDET,  SELARLANGIA,  SCMAMBROISE,  SCPELVEN,  SCMHAGET,  OLERONRIOLON,  SCMDULAVOIR,  CABBOUZOU,  CLIEMERAUDE,  GOMES2,  GRPDUCHEMIN,  SCMBECQUET,  BEDOSSA,  SCMGOURIFF,  SCMPERCHAMPS,  URGCLILANDY,  SCMCHATEAUDE,  BELISAMASELA,  SCMSAINTMART,  MEDICONSULT,  NATESOINS,  SCMBONDY,  BENHAIM2,  BENICHOU3,  SCMLETOUVET,  BENMOUFFOK,  HOUDARD,  MMCRETINIER,  ZUCCHINI,  SCMEVRY,  SCMSAINTGILL,  SCMDESJONQUE,  SCMESPRIT,  MORAILLON,  LATOURRETTE,  SCMJAMA,  LEGOUPIL,  SDFFETANBERR,  SCMLAPINEDE,  SCMMALPICA,  SCMFROGES,  SCMDELENCLOS,  SCMABMEDICAL,  SELASMEDECIN,  SCPNOELBRENU,  SELARLBIECQ,  SCMTHANN,  SCMMARINMANG,  SCIBILLOD,  SHIN,  SCMBELLEVILL,  SCMESTRABLIN,  BINET1,  CLINIQUECONV,  SELARLDESCAY,  BISMUTH1,  BITTAN,  BLANC6,  SCMMBG,  SCMESRLISLE,  SCMCARLINBLA,  SCMCORDELIE2,  SCMBOCHVASIL,  SCMBOCHATONT,  BOCHET,  ROUCHAUD,  NABBE,  SCMYERRES,  SCMTREVOU,  SDFCORMIER,  SCMFOLLANFAN,  TROBAS,  SCMDUDRAC,  SCMMULTIDIS,  SCMPIERREVERT,  SCM80,  CLIESSARTS,  SCMBONNEAULE,  BONNEFOND,  DUTEMS,  LEMAITRE,  SCHOCH,  SCMSTJOSEPH,  BOSSE1,  MSPLESCAILLO,  BOSSUET,  SCMDESTILLEU,  SCMBERGAMOTTE,  SCMMEDIGASTR,  SCHMITT01,  SCMART,  CEDEF,  SCMGASTON,  SCMJALABERT,  LEBAILLIF,  CABGAUGUIN,  LAUBEL,  CABBORABORA,  SCMCARDIO,  SUMIYA,  SCMAMOR,  RUSQUES,  GUEDON,  CABANESTHESI,  SCMSTEFBRENE,  SCMBIZANOS,  SCMSAINTMICH,  BRIAT,  MMCORBIE,  BRUOT,  SISATAMARINIER,  BROLI,  SCMDUPUCH,  LENAOURES,  SDFMOTTU,  SCMVISIOPOLE,  BROYARD,  BRUN,  HANSELER,  BAPTISTE,  SCMFONTANAUD,  SCMFORFELAIS,  GEOFFRAY,  BUVRY,  CABBEZINCARR,  CABBIANCHI,  CABBRESTCARD,  CABCOHADESER,  CABDELAMARE,  CABDELENCLOS,  CABDEPEYCHOT,  CABELGUEN,  CABHOFLANDT,  CABKALBFLEIS,  CABKNORARNAU,  CABLAENNEC,  CABLEROY,  CABMAREAU,  CABMERLEHOOG,  CABPESENTI,  CABPILOTIERE,  CABRABANESSE,  CABRANDON,  THOMAS07,  CABSTGEORGE,  SCMDESERABLE,  ETIENNE2,  BEROUS,  TREGOAT,  NGUYEN19,  SCMBOULONGNE,  DELBES,  SAUQUET,  SUREAU,  ZARD,  SCMATISOR,  MSPORBSANTE,  SCMCAZAUX,  CCNSTDENIS,  SISAEVREUX,  CHAVANEL,  KRESSMANN,  POLYCLIFLEUR,  SCMAULNAY,  LEPINAY,  SCMCHAPRONPO,  SCMPINGUET,  SCMDESAMONTS,  SCMANJOU,  SCMCANTONDOU,  PERRIN9,  SCMCHAROLAIS,  COUDERC1,  PIQUARD,  VISIONFUTURE,  SCMEGLISE96,  CHAUMERON,  CHAVANNES,  SCMSODUVI,  SCMHERBLAY,  SELARLSELAPP,  SCMSAVERY,  SCMCASSIOPE,  SCMCHOLETPER,  CHOSEROT,  CHPSAINTMART,  SELGABRIELLE,  CHRIQUI,  SCMMONTMOREN,  CHVNEHME,  SCMRABIERE,  SCPMICHELET,  CLAVERIE2,  TRAISSAC,  CLEUZIOU,  CLOTDURBET,  SCMMONTGERMO,  SELETCC,  SCMGRANDERAM,  LORIGNY,  SCMSEQUOIA,  COLLARD,  SCMGYNELISLE,  TORRES,  COMTE,  GANTES,  COSNIER2,  SCMHENRYCOTE,  LABBE1,  SCMPONTLABBE,  SCMCOURADETD,  SCMMEDGENE,  SCMBASTIDE,  CPFALLAIN1,  CPFDIETZMULL,  CPFHAASREYNI,  SCMVAUBAN2,  SCMDUDAVID,  SCMALGE,  SCMGUYANAIS,  SCPASMOAK,  DANJOU,  SELARLDANVIN,  MSPBELAIR,  DARAGON,  DAUBERCIES,  SCMDAUGY,  DAUMET0BOISN,  DAVID10,  DEBARGE,  CABCALUIRE,  DECOSTER2,  SCMESCULAPE,  JEUNETMANCY,  DEGOUGE,  BESSE4,  GAILLARD00,  LEDIEU,  MEDSOINS,  ARRAULT,  SISALABASTID,  SCMODF,  PARADOC,  CHFALAISE,  SCMDERKXFERR,  GLADU,  SCMARGOUGES,  DESEZE,  ZANUTTINI,  WILLEMIN1,  REYNES2,  SCMFLEMING29,  SELARLABR3Y,  SELARLLUMIER,  SCMMOULINS,  CABLACHCAR,  SEMAT,  SCMGIREDREVE,  DROMER,  SCMNARDONREI,  MARINI,  SCMCEREZ,  SCMMOULINJOL,  DUGUE,  SCMPASTEUR1,  SCMCHARTREUX,  VIDEAU1,  SCMLESARCADES,  SCMMONTMARTR,  SCMDOUZY,  SCMDUROC,  SCMARCADES,  SCMSTANTOINE,  DUTOUR,  MSDESDOMBES,  SCMDUCHATEAU,  SELARLSHAYNE,  SCPMGCOLLECT,  SELARLVITTE,  ENGEL,  SCMORLY,  RAU,  SCMCAMARGUE,  CASSAGNE,  SCMVILLENEUV,  SCMHAUSSEGUY,  FAUGERE,  FERNANDEZ1,  CHIGNON,  SCMWSF,  FLABEAUTUGAY,  SCMGRANITIERS,  VERY,  SCMCROAS,  SCMDUPRIEURE,  SCMLAROCHE,  FOURNET2,  SCMREGNAULT,  LECOMTE,  WARY,  SELARLMEDCHI,  FROMAGER,  SCMASCLEPIOS,  SCMPAQUERETT,  MASSE1,  CREPIN,  SCMGANNACGUF,  SELASGANSEY,  SCMBHL,  PSDUMAQUIS,  SCMGARSTKAVE,  SCMLABOUREUR,  SCMFAUVELGER,  BONNIOT,  SCMFLEMING,  SCMROCHEGIRE,  MERCIER00,  SCMGOURLAYLE,  SCMSALIES,  POIRIER3,  GRUNBERG,  LECLERC02,  SCMRENONPERR,  SCPJGDS,  SCMGUILLAISG,  SELARLTERANESTH,  TISON,  SCMHALBGEWAC,  LEHUEDE,  SCMMARAISCOL,  GIL,  SELARLCEPAS,  HOOGSTOELMIL,  SCMDESMARIZY,  SCMTERRIERIM,  SCMSIMON,  JACQUETY,  SCMJACQUIERL,  JAMET,  JOURNE,  JULIEN,  SCMHAUTPERLI,  SELARLKAUFFER,  KIELAR,  SCMKORNETZKY,  KORMANN0SERR,  SCMARDAENSRO,  GUYONNET1,  LAGADEC,  LANGLOIS1,  PERINAUD,  SELARLOLATIL,  SCMLAUNAY,  SCMLAUNAYNIC,  SCMLAVERGNE,  SCMSTLUC,  SCMRATELTHIE,  SCMMEDICOR,  LECLERC00,  SCMBLERE,  SELARLOPS,  LENNE,  SCMNGUYENLEP,  LEQUEUX,  ROSTAN,  MMROAILLAN,  SCMNAHONLEXU,  OROUDJI,  SCMMESNER,  LOPEZ01,  SCMMONTGERON,  LORENZATTI,  CABCHAUBARD,  LYONCAEN,  CLIESSONNE,  URGATHISMONS,  MAHOT1,  SCMAUTHIERMA,  MAITRE1,  SCMAESCULAPE,  SCMDELACROIX,  SCMDEPODOLOG,  MARQUE,  SCMDIDOUT,  MATTEI,  MATTER,  SCMMAYAN,  MAYER,  SCMDESANGES,  SCMRUSCADETH,  VAUBAN,  MMTILLEULS,  MICHON,  MIFSUD,  MILANESE,  SCMUGALEMIR,  PETIT5,  MMGECLANCHER,  SCMCHOURAQUI,  MONLOUISDEV2,  MONTALVA,  SCMANNOUN,  SCMPAITRY,  MOUDNIB,  SCMMOUGEOLLE,  HAUBER,  URGHPNP,  NGUYEN18,  SCMRONCHINGU,  SELARLRIOU,  SCMCONTIOTTA,  SCMPERCEVAL,  SCMPECHEVISP,  PERRIER,  SCMLAFAYETTE,  MIGNOT,  SCMBLEYRASTE,  POMES,  SARLDEMETER,  RACHINE,  ROTTIER,  SCMMOULINGUE,  RATOMAHARO,  RAUX,  SCDFREBUFFE,  SELARLPLEYEL,  RUFFENACH,  FAYARD,  GUY,  SCMCEMA,  SELARLUSAADA,  SAMIVALDEMAR,  SCMCADENNESV,  SCMSAUVAGNAC,  SCMRJD,  SCMBRUAY,  SCMCOMBRIT,  SCMCONVERGEN,  SCMDESMEDECI,  SCMEGRIHEBRA,  SCMGENEMARE,  SCMGH,  SCMKENNEDY,  SCMLOEUILLY,  SCMMEDIPSY,  SCMOTTAVYCOS,  SCMSOINSDESOLOGNE,  SCMSTCLEMENT,  SCMSTRENTA,  THOUVENIN1,  VALLOT,  SCMVOILQUINT,  SCMWALDECK,  SCPCORDELIER,  SCPCUNY0RIEH,  SCPLUDGERJUL,  SCPMGMICHELET,  SDFBMJCLINIQ,  SELARLCOLBER,  PECHABRIER,  PAIRON,  SELRIDELLER,  SIMONY,  SISAMSP,  LASNIER3,  SOMPHANETHAB,  SOUFRON,  MAUGET,  CABMILLAS,  SERRA,  VILLEDIEU1,  ZAGROUN, SCMMARANICE, ' +
    'SISAMAYMAT, ' +
    'MMGHYERES, ' +
    'CABVITROLLES, ' +
    'SCMCONDORCET, ' +
    'CABGAUTHERET, ' +
    'SCMVASCU, ' +
    'SCMANREA, ' +
    'SCMMSESS, ' +
    'CABBOCHJACQU, ' +
    'SCMSYCAMORE',
];

export const generatedGroupOptions = convertStringToArray(groupList[0]);
